import axios from 'axios';
import { print } from 'graphql';
import gql from 'graphql-tag';

export default function () {
  return {
    careers: [],
    cityOptions: [],
    page: 0,
    limit: 6,
    total: 0,

    country: null,
    city: null,
    profile: null,

    init() {
      this.loadJobs();
      this.$watch(['country', 'city', 'profile'], (valueCountry, oldValueCountry) => {
        if (valueCountry != oldValueCountry) {
          this.getCityOptions()
          if (valueCountry === "null") {
            this.country = null;
            this.cityOptions = [];
          }
        }
        this.page = 0;
        this.loadJobs();
      });
    },

    loadMoreJobs() {
      this.page++;
      this.loadJobs(true);
    },

    loadJobs(concat) {
      axios({
        url: '/actions/graphql/api',
        method: 'post',
        data: {
          query: print(gql`{
            entries(section: "careers", site: "${window.currentSite}", limit: ${this.limit}, offset: ${this.page * this.limit}, relatedToCategories: [{id:${this.country ?? 'null'}}, {id:${this.city ?? 'null'}}, {id:${this.profile ?? 'null'}}], orderBy: "postDate DESC") {
              title
              url
              postDate
              ...on careers_default_Entry {
                jobSummary
                country {
                  title
                }
                city {
                  title
                }
              }
            }
            entryCount(section: "careers", site: "${window.currentSite}", relatedToCategories: [{id:${this.country ?? 'null'}}, {id:${this.city ?? 'null'}}, {id:${this.profile ?? 'null'}}])
          }`)
        }
      }).then((result) => {
        if (concat) {
          this.careers = this.careers.concat(result.data.data.entries);
        } else {
          this.careers = result.data.data.entries;
        }
        this.total = result.data.data.entryCount;
      }).catch((error) => { });
    },

    getCityOptions() {
      axios({
        url: '/actions/graphql/api',
        method: 'post',
        data: {
          query: print(gql`{
            categories(
              site: "${window.currentSite}"
              relatedTo: ${this.country}
              orderBy: "title ASC"
            ) {
              title
              id
            }
          }`)
        }
      }).then((result) => {
        this.cityOptions = result.data.data.categories;
      }).catch((error) => { });
    }
  };
}
